var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Todo")]),_c('div',{staticClass:"todos"},_vm._l((_vm.allTodos),function(todo){return _c('div',{key:todo.id,staticClass:"todo"},[_vm._v(" "+_vm._s(todo.title)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }